import createTapIcon from '../../../../assets/svg/invoice-intro-tap-create.svg';
import getTapIcon from '../../../../assets/svg/invoice-intro-tap-get.svg';
import personalTapIcon from '../../../../assets/svg/invoice-intro-tap-personal.svg';
import topTapIcon from '../../../../assets/svg/invoice-intro-tap-top.svg';
import { INPUT_REPLACE_TYPES } from '../../../../generic-components/Input/constants';

export const STYLES = {
  HIDDEN: 'hidden',
  APP_LAYOUT:
    'bg-bw02 h-screen pl-[8rem] pc-sm:pl-[22.188rem] pc-md-lg:pl-[22.5rem] pt-[3.688rem] pb-20 w-[72rem] pc-sm:w-[80.5rem] pc-md-lg:w-[93rem] flex flex-col fadeIn',
  APP_LAYOUT_WIZARD: 'absolute inset-0 z-[50] bg-bw02 h-screen w-screen flex flex-col fadeIn py-[50px] px-[50px]',
  STEP_NAV_STYLE: 'w-full flex items-center bg-bw00 py-[14px] px-[40px]',
  NAV_CHILDREN: 'w-full bg-bw00 flex justify-between',
  SUB_CONTENT_CONTAINER: 'h-full border border-bw03 bg-[#F6F7FA] basis-2/5 py-[10px]',
  CONTENT_WRAPPER: 'w-full h-full flex place-content-start relative top-0',
  IFRAME: 'w-full h-full',
  LINED_STEPPER: {
    MAIN_CONTAINER: 'w-[394px] mb-[34px] self-center flex items-center gap-[8px] justify-between',
    STEP_ANIMATION: 'animate-slideRight',
    STEP: 'min-w-[30px] h-[2px] bg-action03 rounded-umd',
    STEP_CONTAINER: 'w-full min-w-[30px] h-[2px] bg-bw03 flex-grow overflow-hidden rounded-umd',
  },
  PAGES: {
    INTRO: {
      MAIN_CONTENT:
        'py-[36px] flex flex-col items-center grow h-full rounded-[8px] border border-bw03 bg-bw00 mt-[35px]',
      CTA: 'h-[54px] w-[295px] flex items-center justify-center font-metricMedium text-bw00 bg-action03 rounded-[4px] mt-auto',
      TAP_LIST_CONTAINER: 'grid grid-cols-2 gap-[16px]',
      TAP_ITEM_WRAPPER:
        'flex flex-col items-center justify-center max-w-[372px] py-[28px] px-[26px] border border-bw03 rounded-[8px] hover:cursor-pointer hover:shadow-light',
      TAP_ITEM_ICON: 'w-[20px] mb-[4px]',
      TAP_HEADING: 'font-metricMedium text-bw08 text-[16px] leading-[24px] text-center',
      TAP_SUB_HEADING: 'font-metric text-bw07 text-[14px] text-center',
      ICON: 'w-[76px] mb-[16px]',
      MAIN_TITLE: 'font-metricMedium text-[24px] text-bw08 leading-[32px] max-w-[500px] text-center mb-[4px]',
      SUB_TITLE: 'font-metric text-[16px] text-bw07 mb-[20px]',
    },
    LOGO: {
      MAIN_CONTENT: 'py-[26px] flex flex-col items-center basis-3/5 h-full border border-bw03 border-r-0 bg-bw00',
      CTA: 'h-[44px] w-[200px] flex items-center justify-center font-metric text-[14px] text-bw00 bg-action03 rounded-[4px] mt-auto',
      TITLE: 'text-[24px] font-metricMedium text-bw08 leading-[32px] mb-[24px]',
      LOGO_LIST_WRAPPER: 'w-[532px] max-h-[190px] h-fit flex flex-wrap p-[10px] gap-[5px] overflow-scroll',
    },
    COLOR: {
      MAIN_CONTENT: 'py-[26px] flex flex-col items-center basis-3/5 h-full border border-bw03 border-r-0 bg-bw00',
      CTA_CONTINUE:
        'h-[44px] w-[200px] flex items-center justify-center font-metric text-[14px] text-bw00 bg-action03 rounded-[4px]',
      CTA_BACK:
        'pr-[20px] pl-[14px] py-[12px] font-metric text-[14px] text-bw08 bg-bw03 rounded-[4px] flex flex-row-reverse items-center',
      CTA_BACK_ICON: 'w-[20px] h-[20px]',
      FOOTER_ACTIONS_WRAPPER: 'mt-auto w-[480px] flex items-center justify-between w-full',
    },
    DETAILS: {
      MAIN_CONTENT: 'py-[26px] flex flex-col items-center basis-3/5 h-full border border-bw03 border-r-0 bg-bw00',
      CTA_CONTINUE:
        'h-[44px] w-[200px] flex items-center justify-center font-metric text-[14px] text-bw00 bg-action03 rounded-[4px]',
      CTA_BACK:
        'pr-[20px] pl-[14px] py-[12px] font-metric text-[14px] text-bw08 bg-bw03 rounded-[4px] flex flex-row-reverse items-center',
      CTA_BACK_ICON: 'w-[20px] h-[20px]',
      TITLE: 'text-[24px] font-metricMedium text-bw08 leading-[32px] mb-[4px]',
      TEXT: 'text-base font-metric text-bw07 leading-[24px] text-center whitespace-pre-line mb-[22px]',
      CHECK_DETAILS_CONTAINER: 'flex items-center w-[512px] h-[80px] border border-bw04 px-[24px] mb-[12px] rounded-lg',
      ACC_DETAILS_CONTAINER: 'flex items-center w-[512px] h-[80px] border border-bw04 px-[24px] rounded-lg',
      DETAILS_ICON: 'w-[22px] h-[22px] mr-[8px]',
      DETAILS_TEXT: 'font-metric text-base text-bw07',
      NAV_BUTTONS_CONTAINER: 'mt-auto w-[480px] flex items-center justify-between w-full',
    },
    PAYMENTS: {
      MAIN_CONTENT:
        'py-[26px] flex flex-col items-center basis-3/5 h-full max-h-[100%] border border-bw03 border-r-0 bg-bw00 overflow-y-auto relative',
      TITLE: 'font-metricMedium text-[1.5rem] text-bw08 mb-[4px]',
      SUB_TITLE: 'font-metric text-[1rem] text-bw07',
      NAV_BUTTONS_CONTAINER_WRAPPER: 'flex items-center justify-center w-full pt-[26px] border-t border-bw03',
      NAV_BUTTONS_CONTAINER: 'w-[512px] flex items-center justify-between',
      PAYMENTS_LIST: {
        CONTAINER: 'flex items-center grow relative w-[512px]',
        PAYMENTS_GROUP_TITLE: 'font-metric text-[14px] text-bw07 mr-[6px]',
        PAYMENTS_GROUP_ICON: 'w-[16px] cursor-pointer',
        PAYMENT_ITEM_CONTAINER: 'w-[512px] mx-auto rounded-[8px] border border-bw03 cursor-pointer hover:shadow-light',
        PAYMENT_ITEM_CONTAINER_EXPAND: 'border border-action02',
        PAYMENT_ITEM_PREVIEW_CONTAINER: 'flex items-center px-[16px] py-[16px]',
        PAYMENT_ITEM_PREVIEW_LOGO_WRAPPER: 'basis-[48px] min-w-[48px] rounded-[6px]',
        PAYMENT_ITEM_PREVIEW_LOGO: 'w-full h-full',
        PAYMENT_ITEM_PREVIEW_CONTENT_WRAPPER: 'flex flex-col flex-grow px-[20px]',
        PAYMENT_ITEM_PREVIEW_MAIN_TITLE: 'font-metricSemibold text-bw08 text-[16px]',
        PAYMENT_ITEM_PREVIEW_MAIN_TITLE_BADGE:
          'after:ml-[6px] after:content-["Recommended"] after:font-metric after:text-[12px] after:text-badgeAmber02 after:bg-badgeAmber00 after:py-[2px] after:px-[8px] after:rounded-md',
        PAYMENT_ITEM_PREVIEW_SUB_TITLE: 'font-metric text-bw07 text-[14px]',
      },
    },
  },
  INVOICE_CREATION: {
    APP_LAYOUT: 'absolute inset-0 z-[50] bg-bw02 h-screen w-screen flex flex-col fadeIn overflow-hidden',
    APP_LAYOUT_NAV_BAR: 'w-full',
    USER_MESSAGE: {
      MAIN_WRAPPER: 'backdrop-blur-sm',
      formEdit: 'animate-fadeIn',
      sideWindow: 'absolute h-full min-w-[600px] ml-auto bg-bw00 animate-slideRightToLeft w-[40%]',
      sideWindowDone: 'absolute h-full min-w-[600px] ml-auto bg-bw00 animate-slideRightToLeft w-[100%]',
      remindersController: 'absolute h-full w-[40%] max-w-[600px] ml-auto bg-bw00 animate-slideRightToLeft',
    },
    NAV_CHILDREN: {
      WRAPPER: 'w-full flex justify-between px-[28px] py-[14px] bg-bw00 border-b-[1px] border-bw02',
      LEFT_CONTENT_WRAPPER: 'flex items-center gap-[16px]',
      CLOSE_FLOW_ICON: 'w-[24px] hover:cursor-pointer hover:shadow-light',
      BREAD_CRUMB_WRAPPER: 'flex items-center gap-[10px]',
      BREAD_CRUMB_INACTIVE_PATH: 'font-metric text-[12px] text-bw07 opacity-70',
      BREAD_CRUMB_ACTIVE_PATH: 'font-metric text-[12px] text-bw08',
      BREAD_CRUMB_FLOW_ICON: 'w-[16px]',
      NAV_TITLE: 'font-metric text-[20px] text-bw08',
      PLACE_HOLDER_DIV: 'opacity-0 w-[208px]',
    },
    CREATION_CONTENT_SWITCH: {
      // WRAPPER: 'w-full max-h-[calc(100%_-_60px)] overflow-y-auto flex flex-col bg-bw01 pb-[30px]',
      WRAPPER: 'flex flex-col grow w-full bg-bw01',
      FORM_CONTENT_WRAPPER: 'flex flex-col grow w-full relative',
    },
    STICKY_HEADER: {
      WRAPPER:
        'w-full relative z-50 py-[18px] px-[28px] bg-bw00 flex justify-center items-center shadow-light border-t-[1px] border-t-bw03',
      INVOICE_DATA_WRAPPER: 'flex flex-col gap-[4px]',
      INVOICE_DATA_ITEM_WRAPPER: 'flex items-center gap-[6px]',
      INVOICE_ID_TITLE: 'font-metric text-[24px] text-bw08',
      INVOICE_AMOUNT_TITLE: 'font-metric text-[1rem] text-bw07',
      ACTIONS_WRAPPER: 'flex items-center gap-[14px]',
      // PREVIEW_BUTTON: 'py-[8px] px-[35px]  h-[40px] max-h-[40px]  min-w-[152px] border border-action03 rounded-[4px] hover:bg-[#019EAC0D]',
      // PREVIEW_BUTTON_DISABLED: 'py-[8px]  h-[40px] max-h-[40px]  min-w-[152px]  px-[35px] border border-action03 rounded-[4px] hover:bg-[#019EAC0D] opacity-[50%]',
      // PREVIEW_BUTTON_TITLE: 'relative pl-[14px] text-action03 font-metric text-[14px] before:content-previewEye before:absolute before:left-0 before:translate-x-[-16px]',
      // PREVIEW_BUTTON_TITLE_DISABLED: 'relative pl-[14px] text-action03 font-metric text-[14px] before:content-previewEye before:absolute before:left-0 before:translate-x-[-16px] opacity-[50%]',
      // CREATE_INVOICE_BUTTON: 'py-[8px] px-[35px]  h-[40px] max-h-[40px] bg-action03 border border-action03 rounded-[4px]',
      // CREATE_INVOICE_BUTTON_DISABLED: 'py-[8px] h-[40px] max-h-[40px] px-[35px] bg-action03 border border-action03 rounded-[4px] opacity-[50%]',
      // CREATE_INVOICE_BUTTON_TITLE: 'text-bw00 font-metric text-[14px]',
      // CREATE_INVOICE_BUTTON_TITLE_DISABLED: 'text-bw00 font-metric text-[14px]',
    },
    CREATION_FORM_WRAPPER: 'flex flex-col w-[80%] max-w-[1076px] h-fit bg-bw00 rounded-[8px] shadow-light',
    INVOICE_CLIENT_SECTION: {
      WRAPPER: 'w-full py-[24px] px-[24px] border-b-[4px] border-bw01 flex flex-col',
      USER_MESSAGE: {
        WRAPPER: 'backdrop-blur-sm',
        FORM_WRAPPER: 'w-[568px] min-h-[100px] bg-bw00 rounded-[12px]',
      },
      CONTENT_WRAPPER:
        'w-full border border-bw03 rounded-[6px] flex flex-col gap-[12px] py-[20px] px-[20px] hover:shadow-light hover:cursor-pointer',
      SECTION_TITLE: 'font-metricRMedium text-[16px] text-bw08',
      SELECT_CLIENT_WRAPPER: 'w-full relative',
      ACTION_ADD_NEW_CLIENT: ' hover:text-action02 relative text-action03 text-[14px] font-metricR',
      ACTION_ADD_NEW_BUTTON: 'w-fit mt-[12px]',
      HIDE_ELEMENT: 'opacity-0',
    },
    RECIPIENT_PRESENTOR: {
      CONTAINER: {
        WRAPPER: 'flex flex-col',
        CLIENT_PROFILE_WRAPPER: 'w-full rounded-[8px] border border-bw03 bg-bw00 mb-[9px] flex flex-row',
        ACTIONS_WRAPPER: 'flex items-center gap-[10px]',
        ACTION_EDIT_CLIENT: 'hover:bg-bw03 rounded-md py-[2px] px-[2px]',
        ACTION_EDIT_CLIENT_TITLE: 'font-metric text-[14px] text-action03',
        ACTION_CLEAR_CLIENT: 'hover:bg-bw03 rounded-md py-[2px] px-[2px]',
        ACTION_CLEAR_CLIENT_TITLE: 'font-metric text-[14px] text-red02',
        INFO_TOOL_TIP: {
          WRAPPER: 'relative w-fit',
          CHILDREN_WRAPPER:
            'absolute z-[9999] bottom-0 left-0 translate-y-[calc(100%+1px)] bg-bw00 rounded-[6px] shadow-light',
          TRIGGER: 'hover:bg-bw01 py-[2px] px-[2px]',
          TRIGGER_TITLE: 'font-metric text-[14px] text-action03',
        },
        ACTIONS_SEPARATOR: 'font-metric text-[14px] text-bw03',
      },
      ACTIVE_RECIPIENT_INFO: {
        WRAPPER: 'flex flex-col gap-[12px] py-[18px] px-[16px] w-[369px]',
        BUSINESS_NAME: 'font-metric text-action03 text-[16px] max-w-[80%] truncate',
        EMAIL:
          'before:content-recipientInfoEmail before:absolute before:left-0 top-0 before:translate-y-[3px] before:translate-x-[90%] pl-[40px] font-metric text-action03 text-[16px]',
        PHONE:
          'before:content-recipientInfoPhone before:absolute before:left-0 top-0 before:translate-y-[3px] before:translate-x-[90%] pl-[40px] font-metric text-action03 text-[16px]',
        ADDRESS:
          'before:content-recipientInfoAddress before:absolute before:left-0 top-0 before:translate-y-[3px] before:translate-x-[90%] pl-[40px] font-metric text-action03 text-[16px]',
      },
    },
    CLIENT_PROFILE: {
      WRAPPER: 'py-[16px] px-[16px] bg-bw00 flex items-center gap-[10px] hover:bg-bw01',
      ADDON_WRAPPER_SINGLE_MODE: 'border-b-[1px] border-bw03',
      ADDON_WRAPPER_LIST_MODE: 'rounded-[8px]',
      NAME_TAG_WRAPPER: 'rounded-[50%] bg-action02 min-w-[34px] w-[34px] h-[34px] flex items-center justify-center',
      INITIALS_TITLE: 'font-metricMedium text-[13px] text-bw00 w-fit',
      CLIENT_DATA_WRAPPER: 'flex flex-col items-baseline w-full',
      CLIENT_NAME: 'font-metricMedium text-bw08 text-[14px] max-w-[80%] truncate',
      CLIENT_EMAIL: 'font-metric text-bw06 text-[14px]',
      BUTTON: 'w-full',
    },
    CREATE_NEW_CLIENT: {
      WRAPPER: 'flex flex-col',
      HEADER_CONTAINER:
        'w-full bg-bw00 flex items-center justify-between px-[24px] py-[18px] rounded-t-[12px] border-b border-bw03',
      MAIN_TITLE: 'font-metricRBold text-bw08 text-[18px] max-w-[80%] truncate',
      CLOSE_ICON: 'w-12px',
      FORM_WRAPPER: 'w-full flex items-center justify-center py-[24px] px-[24px]',
      SUBMIT_BUTTON: 'py-[17px] min-w-[152px]',
      FORM: 'w-full',
    },
    CLIENTS_AUTO_COMPLETE: {
      WRAPPER:
        'absolute w-full z-50 rounded-[8px] bottom-0 left-0 bg-bw00 translate-y-[calc(100%_-_5px)] shadow-chatBotButton flex flex-col max-h-[335px] overflow-y-auto',
      PROFILE_WRAPPER: 'w-full bg-bw01',
      ZERO_STATE_LIST_WRAPPER: 'w-full flex items-center justify-center bg-bw01 py-[16px]',
      ZERO_STATE_LIST_HEADER: 'w-fit font-metricMedium text-bw08 text-[14px]',
      BUTTON:
        'sticky w-full left-0 bottom-0 py-[10px] px-[16px] rounded-[6px] bg-bw00 border-t border-bw01 hover:bg-bw01',
      BUTTON_TITLE: 'font-metric w-fit text-action03 text-[14px] leading-[20px] hover:underline',
    },
    INVOICE_PREVIEW: {
      CONTAINER: 'flex flex-col relative w-full h-full bg-[#F7F7F7]',
      HEADER_WRAPPER: 'flex items-center py-[14px] bg-bw00 w-full border-b border-bw03 px-[28px]',
      CLOSE_ICON: 'w-[20px]',
      IFRAME_WRAPPER: 'h-full py-[15px] px-[20px]',
      IFRAME: 'w-full h-full',
      FOOTER_WRAPPER: 'bg-bw00 w-full flex flex-col shadow-light',
      DISCLAIMER_WRAPPER: 'w-full py-[12px] bg-badgeAmber00 text-center',
      DISCLAIMER:
        'relative font-metric text-[14px] text-bw08 before:absolute before:content-warning before:translate-x-[-30px] pl-[30px]',
      ACTIONS_WRAPPER: 'flex items-center justify-end w-full py-[16px] px-[24px] gap-[12px]',
      ACTIONS_CONTINUE_EDIT: 'h-[54px] px-[35px] border border-action03 rounded-[4px] hover:bg-[#0E5CF40D]',
      ACTIONS_CONTINUE_EDIT_TITLE:
        'relative pl-[14px] text-action03 font-metric text-[14px] before:absolute before:left-0 before:translate-x-[-16px]',
      ACTIONS_CREATE_INVOICE:
        'h-[54px] py-[12px] px-[35px] bg-action03 hover:bg-action04 border border-action03 rounded-[4px]',
      ACTIONS_CREATE_INVOICE_DISABLE: 'py-[8px] px-[35px] bg-bw02 border border-bw03 rounded-[4px]',
      ACTIONS_CREATE_INVOICE_TITLE: 'text-bw00 font-metric text-[14px]',
      ACTIONS_CREATE_INVOICE_TITLE_DISABLED: 'text-bw04 font-metric text-[14px]',
    },
    INVOICE_DATES_PICKER: {
      CONTAINER: 'w-full py-[24px] px-[24px] border-b-[4px] border-bw01',
      CONTENT_WRAPPER:
        'w-full border border-bw03 rounded-[6px] flex gap-[24px] py-[20px] px-[20px] hover:shadow-light hover:cursor-pointer',
      PICKER_WRAPPER: 'basis-1/2 flex flex-col gap-[12px] relative',
      PICKER_TITLE: 'w-full font-metricMedium text-bw08 text-[18px]',
      PICKER_CONTENT_WRAPPER: 'w-full flex items-center',
      PICKER_CONTENT_HEADER: 'font-metric text-bw08 text-[1rem]',
      PICKER_CONTENT_ICON: 'absolute right-[16px] text-bw06 w-[30px]',
      DUE_DATE_PICKER_CONTENT_ICON: 'absolute right-[16px] text-bw08 w-[16px]',
      PICKER_TRIGGER_BUTTON:
        'rounded-[6px] border border-bw07 py-[16px] px-[16px] w-full hover:shadow-light hover:bg-bw01',
      FLOATING_WRAPPER:
        'absolute border border-bw03 rounded-[6px] max-h-[300px] overflow-y-auto left-0 bottom-0 translate-y-[calc(100%-22px)] w-full shadow-chatBotButton bg-bw00 min-w-[260px] z-50',
      FLOATING_WRAPPER_DATE_PICKER:
        'absolute border border-bw03 rounded-[6px] max-h-[300px] overflow-y-auto left-0 bottom-0 translate-y-[calc(100%-22px)] w-fit shadow-chatBotButton bg-bw00 min-w-[260px] z-50',
      DUE_DATE_CONTENT_WRAPPER: 'w-full flex flex-col gap-[4px] relative',
      DUE_DATE_SUB_TITLE: 'font-metric text-bw07 text-[14px]',
      W_16: 'w-[16px]',
      DUE_DATE_TRIGGER_BUTTON: 'py-[21px] px-[16px] border-b-[2px] border-bw02 hover:bg-bw01 w-full',
      DUE_DATE_ITEM_WRAPPER: 'flex flex-col items-baseline w-full',
      DUE_DATE_ITEM_HEADER: 'font-metric text-[1rem] text-bw08',
      DUE_DATE_ITEM_SUB_HEADER: 'font-metric text-bw06 text-[14px]',
    },
    INVOICE_REMINDERS: {
      CONTENT_WRAPPER:
        'w-full flex flex-col border border-bw03 rounded-[6px] px-[20px] py-[20px] gap-[12px] hover:shadow-light',
      HEADER_WRAPPER: 'flex items-center gap-[8px]',
      HEADER: 'font-metricMedium text-[1rem] text-bw08',
      DISCLAIMER: 'font-metric text-[14px] text-bw07 max-w-[80%] break-words',
      ACTIONS_WRAPPER:
        'w-full flex flex-col border border-bw03 rounded-[6px] px-[14px] py-[14px] hover:shadow-light hover:cursor-pointer',
      TOP_ACTIONS: 'w-full flex items-center justify-between pb-[8px] mb-[8px] border-b-[2px] border-bw02',
      TOP_ACTIONS_COUNTER_TITLE_WRAPPER: 'flex items-center gap-[8px]',
      COUNTER_WRAPPER: 'rounded-[50%] w-[20px] h-[20px] flex items-center justify-center bg-action01',
      COUNTER_HEADER: 'font-metric text-action03 text-[14px]',
      TOGGLE_HEADER: 'font-metric text-bw07 text-[1rem]',
      BOTTOM_ACTION: 'font-metric text-[16px] w-fit text-action03 hover:underline',
    },
    INVOICE_REMINDERS_CONTROLLER: {
      PLACE_HOLDER_DIV: 'opacity-0',
      WRAPPER: 'flex flex-col w-full h-full bg-bw00 relative overflow-y-scroll',
      HEADER_CONTAINER: 'flex items-center justify-between py-[14px] bg-bw00 w-full border-b border-bw03 px-[28px]',
      HEADER: 'font-metricMedium text-[18px] text-bw08',
      HERO_WRAPPER: 'py-[20px] px-[20px] flex flex-col gap-[16px] border-b-[4px] border-bw01',
      HERO_HEADER: 'font-metric text-bw07 text-[1rem] max-w-[65%]',
      MASTER_TOGGLE_WRAPPER: 'flex items-center justify-between',
      MASTER_TOGGLE_LABEL_WRAPPER: 'flex items-center gap-[6px]',
      MASTER_TOGGLE_LABEL: 'font-metric text-[18px] text-bw08',
      TOGGLE_LIST_CONTAINER: 'flex flex-col py-[16px] px-[6px] gap-[0px]',
      EXAMPLE_INVOICE_WRAPPER:
        'flex flex-col items-center justify-center w-full h-full bg-bw01 border-t border-bw03 py-[12px]',
      FLOATING_FOOTER_WRAPPER:
        'absolute bottom-0 left-0 w-full bg-bw00 py-[20px] px-[20px] flex items-center justify-end shadow-chatBotButton gap-[12px]',
      FOOTER_ACTION_CANCEL_BUTTON:
        'bg-bw00 border border-action03 rounded-[4px] py-[10px] px-[26px] hover:bg-action04Low',
      FOOTER_ACTION_SAVE_BUTTON:
        'bg-action03 border border-action03 rounded-[4px] py-[10px] px-[26px] w-[142px] hover:bg-action04',
      FOOTER_ACTION_CANCEL_BUTTON_CHILDREN: 'text-action03 font-metric text-[14px]',
      FOOTER_ACTION_SAVE_BUTTON_CHILDREN: 'text-bw00 font-metric text-[14px]',
      INVOICE_EXAMPLE_STYLES: 'font-metricR text-[14px] text-bw07 font-light text-center max-w-[245px] mb-[12px]',
    },
    INVOICE_REMINDER_ITEM: {
      WRAPPER: 'flex items-center justify-between hover:bg-bw02 py-[10px] px-[14px] rounded-[4px]',
      SELECTED: 'bg-bw00',
      TITLES_WRAPPER: 'flex flex-col gap-[4px]',
      REMINDER_TEXT: 'font-metric text-[1rem] text-bw08',
      DUE_DATE: 'font-metric text-[14px] text-bw06',
    },
    INVOICE_PAYMENT_DETAILS: {
      WRAPPER:
        'w-full flex flex-col border border-bw03 rounded-[6px] px-[20px] py-[20px] gap-[12px] hover:shadow-light',
      HEADER_WRAPPER: 'flex items-center gap-[8px]',
      HEADER: 'font-metricMedium text-[1rem] text-bw08',
      DISCLAIMER: 'font-metric text-[14px] text-bw07 max-w-[60%] break-words',
      ACTIONS_WRAPPER:
        'w-full flex flex-col border border-bw03 rounded-[6px] px-[14px] py-[14px] hover:shadow-light hover:cursor-pointer',
      TOP_ACTIONS: 'w-full flex items-center justify-between pb-[8px] mb-[8px] border-b-[2px] border-bw02',
      TOP_ACTIONS_COUNTER_TITLE_WRAPPER: 'flex items-center gap-[8px]',
      TOGGLE_HEADER: 'font-metric text-bw07 text-[1rem]',
    },
    SERVICE_ITEMS_TABLE: {
      TABLE_WRAPPER: 'w-full flex items-center justify-center hidden',
      TABLE: 'w-full border-collapse',
      HEADERS_ROW: 'w-full',
      TH_WRAPPER: 'w-full flex bg-bw01 border border-bw03 rounded-t-[8px] border-b-transparent',
      TR_ITEM_WRAPPER: 'flex items-stretch w-full hover:cursor-pointer hover:bg-bw01',
      FOOTER_WRAPPER:
        'w-full flex border border-bw03 rounded-b-[8px] border-l-bw05 border-l-[2px] hover:bg-bw01 hover:cursor-pointer',
    },
    CELL_COMPONENTS: {
      ITEM_ID: {
        WRAPPER: 'basis-[80px] py-[20px] text-center font-metric text-bw05 text-[14px] border-r border-bw03',
        SELECTED_WRAPPER: 'basis-[80px] py-[20px] text-center font-metric text-bw08 text-[16px] border-r border-bw03',
      },
      ITEM_DESC: {
        WRAPPER:
          'basis-1/3 max-w-[33%] px-[12px] py-[20px] text-left font-metric text-bw05 text-[14px] border-r border-bw03',
        SELECTED_WRAPPER:
          'basis-1/3 max-w-[33%] px-[12px] py-[20px] text-left font-metric text-bw08 text-[16px] border-r border-bw03 hover:bg-action04Low',
        CONTENT: 'max-w-[90%] truncate',
      },
      ITEM_QUANTITY: {
        WRAPPER:
          'relative basis-[90px] flex items-center justify-center font-metric text-bw05 text-[14px] border-r border-bw03',
        SELECTED_WRAPPER:
          'relative basis-[90px] flex items-center justify-center font-metric text-bw08 text-[16px] border-r border-bw03 hover:bg-action04Low',
      },
      ITEM_PRICE: {
        WRAPPER:
          'basis-[124px] px-[12px] py-[20px] flex items-center justify-center font-metric text-bw05 text-[14px] border-r border-bw03',
        SELECTED_WRAPPER:
          'basis-[124px] px-[12px] py-[20px] flex items-center justify-center font-metric text-bw08 text-[16px] border-r border-bw03 hover:bg-action04Low max-w-[124px]',
        CONTENT: 'max-w-[90%] truncate',
      },
      ITEM_REMOVE: {
        WRAPPER: 'grow py-[20px] px-[12px] flex item-center justify-center hover:bg-red01 hover:cursor-pointer',
      },
      PLACEHOLDER: {
        WRAPPER: 'basis-[48px] py-[20px] px-[12px]',
      },
    },
  },
};

export const TEXTS = {
  NAV_FLOW_TITLE: 'INVOICES.NAV_FLOW_TITLE',
  STEP_INTRO: {
    MAIN_TITLE: 'INVOICES.STEP_INTRO.MAIN_TITLE',
    SUB_TITLE: 'INVOICES.STEP_INTRO.SUB_TITLE',
    CTA: 'INVOICES.STEP_INTRO.CTA',
  },
  STEP_LOGO: {
    TITLE: 'INVOICES.STEP_LOGO.TITLE',
    CTA_NEXT: 'INVOICES.STEP_LOGO.CTA_CONTINUE',
    DRAG_N_DROP: {
      TEXT_1: 'INVOICES.STEP_LOGO.DND_TEXT_1',
      TEXT_2: 'INVOICES.STEP_LOGO.DND_TEXT_2',
      TEXT_3: 'INVOICES.STEP_LOGO.DND_TEXT_3',
      TEXT_4: 'INVOICES.STEP_LOGO.DND_TEXT_4',
    },
  },
  STEP_COLOR: {
    TITLE: 'INVOICES.STEP_COLOR.TITLE',
    CTA_NEXT: 'INVOICES.STEP_COLOR.CTA_CONTINUE',
    CTA_BACK: 'INVOICES.STEP_COLOR.CTA_BACK',
  },
  STEP_DETAILS: {
    TITLE: 'INVOICES.STEP_DETAILS.TITLE',
    TEXT: 'INVOICES.STEP_DETAILS.TEXT',
    CHECK_DETAILS: 'INVOICES.STEP_DETAILS.CHECK_DETAILS',
    ACC_DETAILS: 'INVOICES.STEP_DETAILS.ACC_DETAILS',
    CTA_NEXT: 'INVOICES.STEP_DETAILS.CTA_NEXT',
    CTA_BACK: 'INVOICES.STEP_DETAILS.CTA_BACK',
  },
  STEP_PAYMENTS: {
    CONNECT: 'INVOICES.STEP_PAYMENTS.CONNECT',
    TITLE: 'INVOICES.STEP_PAYMENTS.TITLE',
    SUB_TITLE: 'INVOICES.STEP_PAYMENTS.SUB_TITLE',
    PAYMENT_LIST_CONNECTED: 'INVOICES.STEP_PAYMENTS.PAYMENT_LIST_CONNECTED',
    PAYMENT_LIST_NOT_CONNECTED: 'INVOICES.STEP_PAYMENTS.PAYMENT_LIST_NOT_CONNECTED',
    PAYMENT_METHOD_TITLE_STRIPE_CARD: 'INVOICES.STEP_PAYMENTS.PAYMENT_METHOD_TITLE_STRIPE_CARD',
    PAYMENT_METHOD_TITLE_STRIPE_BANK: 'INVOICES.STEP_PAYMENTS.PAYMENT_METHOD_TITLE_STRIPE_BANK',
  },
  INVOICE_CREATION: {
    NAV_CHILDREN: {
      BREAD_CRUMB_MAIN_PATH: 'INVOICE_CREATION.NAV_CHILDREN.BREAD_CRUMB_MAIN_PATH',
      BREAD_CRUMB_INVOICE_NUMBER_PREFIX: 'INVOICE_CREATION.NAV_CHILDREN.BREAD_CRUMB_INVOICE_NUMBER_PREFIX',
      TITLE: 'INVOICE_CREATION.NAV_CHILDREN.TITLE',
    },
    STICKY_HEADER: {
      INVOICE_NUMBER_PREFIX: 'INVOICE_CREATION.STICKY_HEADER.INVOICE_NUMBER_PREFIX',
      INVOICE_AMOUNT: 'INVOICE_CREATION.STICKY_HEADER.INVOICE_AMOUNT',
      ACTION_PREVIEW: 'INVOICE_CREATION.STICKY_HEADER.ACTIONS.PREVIEW',
      ACTION_CREATE: 'INVOICE_CREATION.STICKY_HEADER.ACTIONS.CREATE',
    },
    INVOICE_SERVICES_SECTION: {
      TITLE: 'INVOICE_CREATION.INVOICE_SERVICES_SECTION.TITLE',
      ADD_BUTTON: 'INVOICE_CREATION.INVOICE_SERVICES_SECTION.ADD_BUTTON',
      NAME_INPUT_PLACEHOLDER: 'INVOICE_CREATION.INVOICE_SERVICES_SECTION.NAME_INPUT_PLACEHOLDER',
      DESCRIPTION_INPUT_PLACEHOLDER: 'INVOICE_CREATION.INVOICE_SERVICES_SECTION.DESCRIPTION_INPUT_PLACEHOLDER',
      CREATE_NEW_ITEM: {
        MAIN_TITLE_EDIT: 'INVOICE_CREATION.INVOICE_SERVICES_SECTION.CREATE_NEW_ITEM.MAIN_TITLE_EDIT',
        MAIN_TITLE_CREATE: 'INVOICE_CREATION.INVOICE_SERVICES_SECTION.CREATE_NEW_ITEM.MAIN_TITLE_CREATE',
        SUBMIT_BUTTON_ADD: 'INVOICE_CREATION.INVOICE_SERVICES_SECTION.CREATE_NEW_ITEM.SUBMIT_BUTTON_ADD',
        SUBMIT_BUTTON_SAVE: 'INVOICE_CREATION.INVOICE_SERVICES_SECTION.CREATE_NEW_ITEM.SUBMIT_BUTTON_SAVE',
        DISCARD_POPUP: {
          TITLE: 'INVOICE_CREATION.INVOICE_SERVICES_SECTION.CREATE_NEW_ITEM.DISCARD_POPUP.TITLE',
          SUBTITLE: 'INVOICE_CREATION.INVOICE_SERVICES_SECTION.CREATE_NEW_ITEM.DISCARD_POPUP.SUBTITLE',
          DISCARD_BUTTON: 'INVOICE_CREATION.INVOICE_SERVICES_SECTION.CREATE_NEW_ITEM.DISCARD_POPUP.DISCARD_BUTTON',
          CANCEL_BUTTON: 'INVOICE_CREATION.INVOICE_SERVICES_SECTION.CREATE_NEW_ITEM.DISCARD_POPUP.CANCEL_BUTTON',
        },
      },
    },
    INVOICE_CLIENT_SECTION: {
      BILL_TO: 'INVOICE_CREATION.INVOICE_CLIENT_SECTION.BILL_TO',
      SELECT_CLIENT: 'INVOICE_CREATION.INVOICE_CLIENT_SECTION.SELECT_CLIENT',
      ACTION_ADD_NEW_CLIENT: 'INVOICE_CREATION.INVOICE_CLIENT_SECTION.ACTION_ADD_CLIENT',
      ACTIVE_RECIPIENT_PRESENTOR: {
        ACTIONS: {
          VIEW: 'INVOICE_CREATION.INVOICE_CLIENT_SECTION.ACTIVE_RECIPIENT_PRESENTOR.ACTIONS.VIEW_DETAILS',
          EDIT: 'INVOICE_CREATION.INVOICE_CLIENT_SECTION.ACTIVE_RECIPIENT_PRESENTOR.ACTIONS.EDIT_DETAILS',
          CLEAR: 'INVOICE_CREATION.INVOICE_CLIENT_SECTION.ACTIVE_RECIPIENT_PRESENTOR.ACTIONS.CLEAR',
        },
      },
      CREATE_NEW_CLIENT: {
        TITLE_EDIT: 'INVOICE_CREATION.INVOICE_CLIENT_SECTION.CREATE_NEW_CLIENT.MAIN_TITLE_EDIT',
        TITLE_CREATE: 'INVOICE_CREATION.INVOICE_CLIENT_SECTION.CREATE_NEW_CLIENT.MAIN_TITLE_CREATE',
        SUBMIT_BUTTON_ADD: 'INVOICE_CREATION.INVOICE_CLIENT_SECTION.CREATE_NEW_CLIENT.SUBMIT_BUTTON_ADD',
        SUBMIT_BUTTON_SAVE: 'INVOICE_CREATION.INVOICE_CLIENT_SECTION.CREATE_NEW_CLIENT.SUBMIT_BUTTON_SAVE',
        DISCARD_POPUP: {
          TITLE: 'INVOICE_CREATION.INVOICE_CLIENT_SECTION.CREATE_NEW_CLIENT.DISCARD_POPUP.TITLE',
          SUBTITLE: 'INVOICE_CREATION.INVOICE_CLIENT_SECTION.CREATE_NEW_CLIENT.DISCARD_POPUP.SUBTITLE',
          DISCARD_BUTTON: 'INVOICE_CREATION.INVOICE_CLIENT_SECTION.CREATE_NEW_CLIENT.DISCARD_POPUP.DISCARD_BUTTON',
          CANCEL_BUTTON: 'INVOICE_CREATION.INVOICE_CLIENT_SECTION.CREATE_NEW_CLIENT.DISCARD_POPUP.CANCEL_BUTTON',
        },
      },
    },
    DISCARD_POPUP: {
      TITLE: 'INVOICE_CREATION.DISCARD_POPUP.TITLE',
      DESCRIPTION: 'INVOICE_CREATION.DISCARD_POPUP.DESCRIPTION',
      OK_BUTTON: 'INVOICE_CREATION.DISCARD_POPUP.OK_BUTTON',
      CANCEL_BUTTON: 'INVOICE_CREATION.DISCARD_POPUP.CANCEL_BUTTON',
    },
    INVOICE_REMINDERS: {
      MAIN_TITLE: 'INVOICE_CREATION.INVOICE_REMINDER_SECTION.MAIN_TITLE',
      MASTER_TOGGLE_LABEL: 'INVOICE_CREATION.INVOICE_REMINDER_SECTION.MASTER_TOGGLE_LABEL',
      REMINDERS_CONTROLLER_TRIGGER: 'INVOICE_CREATION.INVOICE_REMINDER_SECTION.REMINDERS_CONTROLLER_TRIGGER',
      REMINDERS_DISCLAIMER: 'INVOICE_CREATION.INVOICE_REMINDER_SECTION.REMINDERS_DISCLAIMER',
      REMINDERS_MAIN_DISCLAIMER: 'INVOICE_CREATION.INVOICE_REMINDER_SECTION.REMINDERS_MAIN_DISCLAIMER',
      ACTION_CANCEL: 'INVOICE_CREATION.INVOICE_REMINDER_SECTION.ACTION_CANCEL',
      ACTION_SAVE: 'INVOICE_CREATION.INVOICE_REMINDER_SECTION.ACTION_SAVE',
    },
    INVOICE_PAYMENTS: {
      MAIN_TITLE: 'INVOICE_CREATION.INVOICE_PAYMENT_DETAILS_SECTION.MAIN_TITLE',
      DISCLAIMER: 'INVOICE_CREATION.INVOICE_PAYMENT_DETAILS_SECTION.DISCLAIMER',
      CHECK_TOGGLE_LABEL: 'INVOICE_CREATION.INVOICE_PAYMENT_DETAILS_SECTION.CHECK_TOGGLE_LABEL',
      BANK_TOGGLE_LABEL: 'INVOICE_CREATION.INVOICE_PAYMENT_DETAILS_SECTION.BANK_TOGGLE_LABEL',
    },
    CELL_COMPONENTS: {
      ITEM_ID: {
        WRAPPER: 'basis-[80px] py-[20px] text-center font-metric text-bw05 text-[14px] border-r border-bw03',
      },
    },
  },
} as const;

export const ONBOARDING_VIEWS_MAP = {
  INTRO: 0,
  LOGO: 1,
  COLOR: 2,
  DETAILS: 3,
  PAYMENTS: 4,
  PRELOAD: 9,
};

export const STEPS_DATA = {
  PAGES: {
    INTRO: {
      TAPS_LIST: [
        {
          ICON: createTapIcon,
          HEADING: 'INVOICES.STEP_INTRO.TAP_LIST.CREATE.TITLE',
          SUB_HEADING: 'INVOICES.STEP_INTRO.TAP_LIST.CREATE.SUB_TITLE',
        },
        {
          ICON: getTapIcon,
          HEADING: 'INVOICES.STEP_INTRO.TAP_LIST.GET.TITLE',
          SUB_HEADING: 'INVOICES.STEP_INTRO.TAP_LIST.GET.SUB_TITLE',
        },
        {
          ICON: personalTapIcon,
          HEADING: 'INVOICES.STEP_INTRO.TAP_LIST.PERSONAL.TITLE',
          SUB_HEADING: 'INVOICES.STEP_INTRO.TAP_LIST.PERSONAL.SUB_TITLE',
        },
        {
          ICON: topTapIcon,
          HEADING: 'INVOICES.STEP_INTRO.TAP_LIST.STAY.TITLE',
          SUB_HEADING: 'INVOICES.STEP_INTRO.TAP_LIST.STAY.SUB_TITLE',
        },
      ],
    },
    LOGO: {
      EXIT_FLOW_STEP_DESTINATION: 0,
    },
    COLOR: {
      STEP_BACK_DESTINATION: 1,
    },
    DETAILS: {
      STEP_BACK_DESTINATION: 2,
    },
    PAYMENTS: {
      STEP_BACK_DESTINATION: 3,
    },
  },
};

export const ACTUAL_FLOW_STEPS = 3;

export const STEPS_TO_AVOID_SUB_MENU = [ONBOARDING_VIEWS_MAP.INTRO, ONBOARDING_VIEWS_MAP.PRELOAD];

export const STEPS_TO_SHOW_EXIT_BTN = [ONBOARDING_VIEWS_MAP.LOGO];

export const STEPS_TO_AVOID_PROFILE_NAVBAR = [
  ONBOARDING_VIEWS_MAP.LOGO,
  ONBOARDING_VIEWS_MAP.COLOR,
  ONBOARDING_VIEWS_MAP.DETAILS,
  ONBOARDING_VIEWS_MAP.PAYMENTS,
];

export const SUBMIT_TYPES = {
  LOGO: {
    LILI_LOGO_ID: 'liliLogoId',
    LOGO_FILE_ID: 'logoFileId',
  },
  COLOR: {
    PICKED_COLOR: 'pickedColor',
    NAVIGATE_BACK: 'navigateBack',
  },
  DETAILS: {
    CHECK_DETAILS: 'checkDetails',
    ACC_DETAILS: 'accDetails',
    NAVIGATE_BACK: 'navigateBack',
  },
  PAYMENTS: {
    NAVIGATE_BACK: 'navigateBack',
    CONNECTION_SUCCESS: 'connectionSuccess',
    STRIPE_REDIRECT: 'stripeIframe',
  },
};

export const iFrameQueryParams = {
  BASE_URL: process.env.REACT_APP_HOST_ENV
    ? 'https://integ-invoice.lili.co/'
    : process.env.REACT_APP_NODE_ENV === 'production'
      ? 'https://invoice.lili.co/'
      : 'https://integ-invoice.lili.co/',
  CUSTOMIZATION_INVOICE: 'customizationInvoice',
  ORIGIN: 'origin',
  BRAND_COLOR: 'brandColor',
  LOGO_URL: 'logoUrl',
  CUSTOM_LOGO_PATH: 'customLogoPath',
  SHOW_BANK_ACCOUNT: 'showbankaccount',
  SHOW_CHECK_DETAILS: 'showcheckdetails',
  INVOICE_ID: 'invoice',
  CREATION_PROCESS: 'creationProcess',
};

export const INVOICE_CUSTOMIZATION_INITIAL_DATA = {
  showEmail: true,
  showPhone: true,
  showAddress: true,
  enableAchPaymentMethod: true,
  enableCheckDepositPaymentMethod: true,
  brandColor: '',
  logoFileId: '',
  templateId: '',
  liliLogoId: '',
  templateVersion: 0,
  finishCustomization: false,
};

export const FILE_FORMATS = ['image/jpeg', 'image/png', 'image/svg+xml', 'application/pdf'];

export const MAX_FILE_SIZE = 5242880;

export const PAYMENT_METHOD_TYPES = {
  STRIPE_BANK: 'BANK_TRANSFER',
  STRIPE_CARD: 'DEBIT_OR_CREDIT_CARD',
  CASH_APP: 'CASHAPP',
  VENMO: 'VENMO',
  PAYPAL: 'PAYPAL',
};

export const DESCRIPTION_TYPES = {
  HTML: 'HTML',
  TEXT: 'TEXT',
};

export const USER_MESSAGE_TYPES = {
  FORM_EDIT: 'formEdit',
  SIDE_WINDOW: 'sideWindow',
  ZERO_STATE: '',
};

export const CREATION_CONTENT_TYPE = {
  ERROR: 0,
  LOADER: 1,
  CONTENT: 2,
};

export const INVOICE_CREATION_INITIAL_DATA = {
  invoiceService: {
    amount: 0.0,
    invoiceServiceItems: [],
  },
  issueDate: new Date().toISOString(),
  invoicePaymentTerm: {
    dueDate: '',
    dueDateDescription: 'UPON_RECEIPT',
    achPaymentMethod: false,
    checkDepositPaymentMethod: true,
  },
  invoiceStatus: 'DRAFT',
};

export const CREATE_NEW_CLIENT_INPUTS = [
  {
    TITLE: 'Client or Company Name',
    TYPE: 'name',
    VALIDATION: /^(?=.*[a-zA-Z0-9]).+$/,
    ERROR: 'Please enter a valid Client or Company name.',
    AUTOCOMPLETE: 'none',
    MAX_LENGTH: 50,
    VALUE: '',
    DISABLED: false,
    REPLACE: 'TRIM',
  },
  {
    TITLE: 'Email',
    TYPE: 'email',
    VALIDATION: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    ERROR: 'Please check your email again.',
    AUTOCOMPLETE: 'email',
    MAX_LENGTH: 200,
    VALUE: '',
    DISABLED: false,
  },
  {
    TITLE: 'Phone Number (Optional)',
    TYPE: 'phone',
    VALIDATION: /^.{10,}$/,
    ERROR: 'Please enter a valid phone number.',
    AUTOCOMPLETE: 'phone',
    MAX_LENGTH: 10,
    VALUE: '',
    REPLACE: INPUT_REPLACE_TYPES.PHONE,
    DISABLED: false,
    INITIAL_FORMAT: true,
    OPTIONAL: true,
  },
  {
    TITLE: 'Billing Address (Optional)',
    TYPE: 'address',
    VALIDATION: '',
    ERROR: 'none',
    AUTOCOMPLETE: 'none',
    MAX_LENGTH: 200,
    VALUE: '',
    DISABLED: false,
    OPTIONAL: true,
  },
];

export const CREATE_NEW_PRODUCT_INPUTS = [
  {
    TITLE: 'Item Name',
    TYPE: 'name',
    VALIDATION: /^(?=.*[a-zA-Z0-9]).+$/,
    ERROR: 'Please enter a valid product name.',
    AUTOCOMPLETE: 'none',
    MAX_LENGTH: 200,
    VALUE: '',
    DISABLED: false,
    REPLACE: 'TRIM',
  },
  {
    TITLE: 'Item Description (Optional)',
    TYPE: 'itemDescription',
    VALIDATION: '',
    ERROR: 'PLACEHOLDER',
    AUTOCOMPLETE: 'none',
    MAX_LENGTH: 250,
    VALUE: '',
    DISABLED: false,
  },
  {
    TITLE: 'Price ($)',
    TYPE: 'amount',
    VALIDATION: /.*[0-9].*/,
    ERROR: 'Please set a price for the product.',
    AUTOCOMPLETE: 'none',
    VALUE: '',
    DISABLED: false,
    REPLACE: 'CURRENCY',
    INITIAL_FORMAT: true,
    MAX_LENGTH: 12,
    MAX_PRICE: 1000000,
    OPTIONAL: true,
  },
];

export const DATE_PICKER_TYPES = {
  ISSUE_DATE: 'ISSUE_DATE',
};

export const DUE_DATE_OPTIONS = [
  {
    title: 'Upon receipt',
    value: 1,
    id: 'UPON_RECEIPT',
  },
  {
    title: 'Within 7 days',
    value: 7,
    id: 'WITHIN_7_DAYS',
  },
  {
    title: 'Within 14 days',
    value: 14,
    id: 'WITHIN_14_DAYS',
  },
  {
    title: 'Within 30 days',
    value: 30,
    id: 'WITHIN_30_DAYS',
  },
  {
    title: 'Within 60 days',
    value: 60,
    id: 'WITHIN_60_DAYS',
  },
];

export const TOGGLE_TYPES = {
  MASTER: 'MASTER',
};

export const TABLE_HEADERS_VALUES = {
  ROW_ID: 'rowId',
  ITEM_NAME: 'itemName',
  ITEM_DESC: 'itemDesc',
  QTY: 'quantity',
  ITEM_PRICE: 'itemPrice',
  ACTION_COMPONENT: 'actionComponent',
};

export const TABLE_HEADERS = [
  {
    title: '#',
    value: TABLE_HEADERS_VALUES.ROW_ID,
    styles: 'basis-[80px] py-[10px] flex items-center justify-center font-metric text-bw07 text-[14px]',
  },
  {
    title: 'Item Name',
    value: TABLE_HEADERS_VALUES.ITEM_NAME,
    styles:
      'basis-1/3 max-w-[33%] px-[12px] py-[10px] flex items-center justify-start font-metric text-bw07 text-[14px]',
  },
  {
    title: 'Item Description',
    value: TABLE_HEADERS_VALUES.ITEM_DESC,
    styles:
      'basis-1/3 max-w-[33%] px-[12px] py-[10px] flex items-center justify-start font-metric text-bw07 text-[14px]',
  },
  {
    title: 'Quantity',
    value: TABLE_HEADERS_VALUES.QTY,
    styles: 'basis-[90px] flex py-[10px] items-center justify-center font-metric text-bw07 text-[14px]',
  },
  {
    title: 'Price ($)',
    value: TABLE_HEADERS_VALUES.ITEM_PRICE,
    styles: 'basis-[124px] flex py-[10px] items-center justify-center font-metric text-bw07 text-[14px]',
  },
  {
    title: '',
    value: TABLE_HEADERS_VALUES.ACTION_COMPONENT,
    styles: 'basis-[48px] flex py-[10px] items-center justify-center',
  },
];

export const FOOTER_ITEMS = {
  rowId: {
    value: 99,
    styles:
      'basis-[80px] py-[20px] text-center font-metric text-bw05 text-[14px] border border-bw03 border-l-[2px] border-l-bw04 border-t-[0px] rounded-bl-[8px]',
    type: '',
  },
  itemName: {
    value: 'Select a product/service',
    styles:
      'basis-1/3 px-[12px] py-[20px] text-left font-metric text-bw05 text-[14px] border border-bw03 border-t-[0px] border-l-[0px]',
    type: '',
  },
  itemDesc: {
    value: '',
    styles:
      'basis-1/3 px-[12px] py-[20px] text-left font-metric text-bw00 text-[14px] border border-bw03 border-t-[0px] border-l-[0px]',
    type: '',
  },
  quantity: {
    value: '1',
    styles:
      'basis-[90px] flex items-center justify-center border border-bw03 border-t-[0px] border-l-[0px] font-metric text-bw05 text-[14px]',
    type: '',
  },
  itemPrice: {
    value: '$0.00',
    styles:
      'basis-[124px] px-[12px] py-[20px] text-left font-metric text-bw05 text-[14px] border border-bw03 border-t-[0px] border-l-[0px]',
    type: '',
  },
  actionComponent: {
    value: '',
    styles:
      'basis-[48px] py-[20px] px-[12px] text-center font-metric text-bw05 text-[14px] border border-bw03 border-t-[0px] border-l-[0px]',
    type: '',
  },
};

export const MAX_INVOICE_AMOUNT = 1000000;
